import type { Stripe } from "@stripe/stripe-js";
import { supabase } from "@/integrations/supabase/client";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function getStripeEnvironment(): "sandbox" | "live" {
  return clientToken?.startsWith("pk_live_") ? "live" : "sandbox";
}

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    if (!clientToken) {
      throw new Error("VITE_PAYMENTS_CLIENT_TOKEN is not set");
    }
    // Dynamic import so @stripe/stripe-js (and the injected stripe.js
    // script) only loads when checkout is actually needed.
    stripePromise = import("@stripe/stripe-js").then(({ loadStripe }) =>
      loadStripe(clientToken)
    );
  }
  return stripePromise;
}

export async function createCheckoutSession(priceId: string): Promise<string> {
  const { data, error } = await supabase.functions.invoke("create-checkout", {
    body: {
      priceId,
      environment: getStripeEnvironment(),
      returnUrl: `${window.location.origin}/billing/return?session_id={CHECKOUT_SESSION_ID}`,
    },
  });
  if (error || !data?.clientSecret) {
    throw new Error(error?.message || "Failed to create checkout session");
  }
  return data.clientSecret;
}

export async function openBillingPortal(): Promise<void> {
  const { data, error } = await supabase.functions.invoke("create-portal-session", {
    body: {
      environment: getStripeEnvironment(),
      returnUrl: `${window.location.origin}/settings/billing`,
    },
  });
  if (error || !data?.url) {
    throw new Error(error?.message || "Failed to open billing portal");
  }
  window.open(data.url, "_blank");
}
